/** @jsx jsx */
import { memo, useMemo } from 'react';
import { css, jsx } from '@emotion/core';
import Button from '@atlaskit/button/standard-button';
import ArrowleftIcon from '@atlaskit/icon/glyph/chevron-left-large';
import ArrowrightIcon from '@atlaskit/icon/glyph/chevron-right-large';
import { DN800, N70, N800 } from '@atlaskit/theme/colors';
var headingColor = {
  light: "var(--ds-text-highEmphasis, ".concat(N800, ")"),
  dark: "var(--ds-text-highEmphasis, ".concat(DN800, ")")
};
var headingStyles = css({
  display: 'flex',
  padding: '0 0 13px 0',
  color: "var(--ds-text-highEmphasis, ".concat(N800, ")"),
  fontWeight: 'bold'
});

var getMonthAndYearStyles = function getMonthAndYearStyles() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'light';
  return css({
    flexBasis: '100%',
    color: headingColor[mode],
    textAlign: 'center'
  });
};

var arrowLeftStyles = css({
  marginLeft: 8
});
var arrowRightStyles = css({
  marginRight: 8
});
var Heading = /*#__PURE__*/memo(function Heading(_ref) {
  var monthLongTitle = _ref.monthLongTitle,
      year = _ref.year,
      handleClickPrev = _ref.handleClickPrev,
      handleClickNext = _ref.handleClickNext,
      mode = _ref.mode,
      testId = _ref.testId;
  var monthAndYearStyles = useMemo(function () {
    return getMonthAndYearStyles(mode);
  }, [mode]);
  return jsx("div", {
    css: headingStyles,
    "aria-hidden": "true"
  }, jsx(Button, {
    css: arrowLeftStyles,
    appearance: "subtle",
    spacing: "none",
    tabIndex: -1,
    onClick: handleClickPrev,
    testId: testId && "".concat(testId, "--previous-month"),
    iconBefore: jsx(ArrowleftIcon, {
      label: "Last month",
      size: "medium",
      primaryColor: "var(--ds-text-lowEmphasis, ".concat(N70, ")")
    })
  }), jsx("div", {
    // eslint-disable-next-line @repo/internal/react/consistent-css-prop-usage
    css: monthAndYearStyles,
    "data-testid": testId && "".concat(testId, "--current-month-year")
  }, "".concat(monthLongTitle, " ").concat(year)), jsx(Button, {
    css: arrowRightStyles,
    appearance: "subtle",
    spacing: "none",
    tabIndex: -1,
    onClick: handleClickNext,
    testId: testId && "".concat(testId, "--next-month"),
    iconBefore: jsx(ArrowrightIcon, {
      label: "Next month",
      size: "medium",
      primaryColor: "var(--ds-text-lowEmphasis, ".concat(N70, ")")
    })
  }));
});
Heading.displayName = 'Heading';
export default Heading;